import type { CampaignFormState } from "./campaign-form-fields";

export function campaignFormToRecord(
  record: Record<string, unknown>
): CampaignFormState {
  const amountType = String(record.amount_type ?? "variable");
  const fixedAmount =
    record.fixed_amount ??
    (amountType === "fixed" &&
    record.min_contribution !== null &&
    record.min_contribution !== undefined &&
    record.max_contribution !== null &&
    record.max_contribution !== undefined &&
    String(record.min_contribution) === String(record.max_contribution)
      ? record.min_contribution
      : "");

  return {
    ...record,
    donation_type: record.type_of_donation ?? record.donation_type ?? "",
    donation_type_name:
      record.type_of_donation_name ?? record.donation_type_name ?? "",
    main_category: record.category ?? record.main_category ?? "",
    main_category_name: record.category_name ?? record.main_category_name ?? "",
    sub_category: record.sub_category ?? "",
    sub_category_name:
      record.sub_category_title ?? record.sub_category_name ?? "",
    amount_type: amountType,
    fixed_amount: fixedAmount,
    min_contribution: record.min_contribution ?? "",
    max_contribution: record.max_contribution ?? "",
    is_active: record.is_active !== false,
    allow_donation_after_target: record.allow_donation_after_target === true,
  };
}
